module.exports = __webpack_public_path__ + "img/img_13.5ca13131.jpg";